export const actionTypes = {
  SET_AUTHORIZE_LIST: "SET_AUTHORIZE_LIST",
  SET_AUTHORIZE_INFO_LIST: "SET_AUTHORIZE_INFO_LIST",
  SET_ACTIVE_LIST: "SET_ACTIVE_LIST",
  SET_AUTHORIZE_MODEL: "SET_AUTHORIZE_MODEL",
  SET_ACTIVE_LOG: "SET_ACTIVE_LOG",
  SET_ACTIVE_DETAIL: "SET_ACTIVE_DETAIL"
};